<mat-toolbar color="accent">
  Edit {{ data.restriction.user.name }}
</mat-toolbar>
<mat-dialog-content>
  <pr-user-restriction-form
    [scheduleGroup]="scheduleGroup"
    [ipOverrideGroup]="ipOverrideGroup"
  />
</mat-dialog-content>
<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="saveDisabled$ | async"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
